import { tenantBranding } from '../services/config';

const avatar = require('../assets/img/avatar.jpg')
const bg_1 = require('../assets/img/bg_1.jpg')
const bg_2 = require('../assets/img/bg_2.jpg')
const logov1 = require('../assets/img/famla.png')
const mail = require('../assets/img/send-mail.png')
const famla = require('../assets/img/famla.png')
const famlaSimple = require('../assets/img/logo famla simple.png')
const l1 = require('../assets/img/l1.png')
const l2 = require('../assets/img/l2.png')
const logoUrl = require('../assets/img/logoV1.png')
const process = require('../assets/img/img/process.png')
const newProcess = require('../assets/img/img/newProcess.png')
const folder = require('../assets/img/img/folder.png')
const newFolder = require('../assets/img/img/newFolder.png')
const needInspiration = require('../assets/img/img/needInspiration.png')
const map = require('../assets/img/map.png')

const Images = {
    avatar,
    bg_1,
    bg_2,
    famla,
    famlaSimple,
    logov1,
    mail,
    l1,
    l2,
    process,
    newProcess,
    newFolder,
    folder,
    needInspiration,
    logoUrl,
    map
};

/**
 * Récupère le logo approprié selon le thème et la configuration tenant
 * @param theme 'light' | 'dark'
 * @returns URL du logo (tenant si configuré, sinon Famla par défaut)
 */
export const getTenantLogo = (theme: 'light' | 'dark' = 'light'): string => {
    if (!tenantBranding.enabled) {
        return Images.logov1;
    }
    
    if (theme === 'dark' && tenantBranding.logoDarkUrl) {
        return tenantBranding.logoDarkUrl;
    }
    if (theme === 'light' && tenantBranding.logoLightUrl) {
        return tenantBranding.logoLightUrl;
    }
    
    return tenantBranding.logoUrl || Images.logov1;
};

/**
 * Récupère le nom de l'application (tenant si configuré, sinon Famla)
 */
export const getTenantAppName = (): string => {
    return tenantBranding.appName;
};

export default Images